import { List, Typography } from "@mui/material"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../constants/i18n"
import { ScrollableLayout } from "../../layouts/ScrollableLayout"

import { HierarchicalListItem } from "../HierarchicalListItem"

import * as Styled from "./HierarchicalList.styled"

export const HierarchicalList = (props) => {
    const {
        className,
        data,
        defaultIcon,
        title,
        onCancel,
        onClick,
        ...listProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    return <Styled.Container className={className}>
        <Typography variant="H3">{title}</Typography>
        <Styled.Form>
            <ScrollableLayout
                content={
                    <List {...listProps}>
                        {
                            data.map(listItem =>
                                <HierarchicalListItem
                                    {...listItem}
                                    defaultIcon={defaultIcon}
                                    key={listItem.value}
                                    onClick={onClick}
                                />)
                        }
                    </List>
                }
                buttons={
                    <Styled.CancelButton
                        id="list-cancel-button"
                        onClick={onCancel}
                        variant="outlined"
                    >
                        {t(I18N_NAMESPACE, "components.hierarchicalList.cancel")}
                    </Styled.CancelButton>
                }
            />
        </Styled.Form>
    </Styled.Container>
}

HierarchicalList.propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object),
    defaultIcon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
}

